import AppLayout from "@/layouts/AppLayout.vue";
import IdentityDuplicateReviewListView from "@/views/identityDuplicateReview/IdentityDuplicateReviewListView.vue";
import IdentityDuplicateReviewDetailView from "@/views/identityDuplicateReview/IdentityDuplicateReviewDetailView.vue";

export default [
  {
    path: '/identity-duplicate-reviews',
    name: 'identityDuplicateReviews',
    component: IdentityDuplicateReviewListView,
    meta: {
      parent: 'usersManagement',
      related: 'identityDuplicateReviews',
      layout: AppLayout,
      requiresAuth: true,
      inNav: true,
      permissions: ['GET_IDENTITY_DUPLICATE_REVIEW']
    }
  },
  {
    path: '/identity-duplicate-reviews/:id',
    name: 'identityDuplicateReviewDetail',
    component: IdentityDuplicateReviewDetailView,
    meta: {
      parent: 'usersManagement',
      related: 'identityDuplicateReviews',
      layout: AppLayout,
      requiresAuth: true,
      inNav: false,
      permissions: ['GET_IDENTITY_DUPLICATE_REVIEW']
    }
  },
];
